import MediaQueries from '../../shared/helpers/MediaQueries';

/**
 * Class Menu Primary.
 */
export default class Seo {
  public static seeMoreSeo(moreSeo: string) {
    const moreSeoElt: HTMLElement = document.querySelector(moreSeo);

    if (moreSeoElt) {
      const contentHidden: NodeListOf<HTMLElement> = document.querySelectorAll(
        '.c-seo__blocContent > *'
      );

      // For Tablet & desktop
      if (
        moreSeoElt.dataset.disableHiddenText === '1' &&
        !MediaQueries.mobileMedia.matches
      ) {
        moreSeoElt.hidden = true;
      } else {
        // Start SEO in page
        contentHidden.forEach((content) => {
          content.classList.toggle('is-active');
        });

        moreSeoElt.addEventListener(
          'click',
          () => {
            moreSeoElt.classList.toggle('is-clicked');
            contentHidden.forEach((content) => {
              content.classList.toggle('is-active');
            });
          },
          { passive: true }
        );
      }
    }
  }
}
